module.exports = __webpack_public_path__ + "static/media/saturday-in-spanish.c11180d0.png";